import React from 'react';
import { RISK_TIERS, TIER_ORDER } from '../../../utils/riskTier';

const LEVEL_DETAIL = {
  BASELINE: {
    prob:  'Estimated under 25% chance',
    gloss: 'less than about 1 in 4',
    desc:  'Low chance that toxins are above the level considered safe for swimming. Normal lake activities with the usual common sense.',
    who:   'Everyone can enjoy the lake normally.',
  },
  ELEVATED: {
    prob:  'Estimated 25–75% chance',
    gloss: 'roughly 1 in 4 to 3 in 4',
    desc:  'Cyanobacteria are present and may be increasing, so there\'s a moderate chance toxins are above the safe level. Look closely at the water before you get in.',
    who:   'Adults: use your judgment, but look the water over first. Children: if anything looks green or cloudy, or smells musty, pick another activity. Pets: keep them out entirely.',
  },
  ADVISORY: {
    prob:  'Estimated over 75% chance',
    gloss: 'more than 3 in 4',
    desc:  'High chance that toxins are above the safe level. A significant bloom is present. Stay out of the water.',
    who:   'Adults: stay out of the water. Children: keep them away from the shoreline. Pets: no water contact at all.',
  },
  WARNING: {
    prob:  'Estimated over 90% chance',
    gloss: 'better than 9 in 10',
    desc:  'Very high chance of dangerous toxin levels, confirmed by sensors, reports, and/or lab testing. Everyone out.',
    who:   'Everyone stays out — no swimming, wading, boating, or fishing. Keep all pets completely away.',
  },
};

export default function RiskLevelsModal({ onClose }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}
      onClick={onClose}>
      <div style={{ background: '#fff', borderRadius: 20, padding: 32, maxWidth: 520, width: '100%', maxHeight: '90vh', overflow: 'auto' }}
        onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 18 }}>
          <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 20, fontWeight: 700, color: '#1e293b' }}>Our Risk Levels</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, color: '#94a3b8', cursor: 'pointer' }}>✕</button>
        </div>
        <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.55, marginBottom: 18 }}>
          Each level is our estimate of how likely it is that cyanotoxins are above the level considered safe for swimming — based on real-time sensor data, community reports, and lab results when we have them. <strong>We can't measure toxins directly from the buoy, so these are estimates, not test results.</strong> The buoy light on your lake matches these colors.
        </p>
        {TIER_ORDER.map(key => {
          const tc = RISK_TIERS[key];
          const detail = LEVEL_DETAIL[key];
          return (
            <div key={key} style={{ display: 'flex', gap: 14, padding: 16, borderRadius: 12, marginBottom: 10, background: tc.bg, border: `1px solid ${tc.border}` }}>
              <div style={{ width: 18, height: 18, borderRadius: '50%', background: tc.color, flexShrink: 0, marginTop: 2 }} />
              <div>
                <strong style={{ fontSize: 15, color: tc.color, display: 'block', marginBottom: 2 }}>{tc.label}</strong>
                <span style={{ fontSize: 12, color: tc.color, fontWeight: 600, opacity: 0.75, display: 'block', marginBottom: 5 }}>
                  {detail.prob} <span style={{ fontWeight: 400, fontStyle: 'italic' }}>({detail.gloss})</span>
                </span>
                <p style={{ fontSize: 13, color: '#475569', lineHeight: 1.55, margin: '0 0 6px 0' }}>{detail.desc}</p>
                <p style={{ fontSize: 13, color: '#64748b', lineHeight: 1.5, margin: 0, fontStyle: 'italic' }}>{detail.who}</p>
              </div>
            </div>
          );
        })}
        <div style={{ padding: 14, borderRadius: 10, background: '#f8f7f4', marginTop: 8, fontSize: 13, color: '#64748b', lineHeight: 1.5 }}>
          <strong>Trust your eyes over the app.</strong> These levels are estimates. If you see scum or green water, or smell something off, stay out and treat it as a Warning no matter what this screen says.
        </div>
      </div>
    </div>
  );
}
